import { render, staticRenderFns } from "./data-authority-update.vue?vue&type=template&id=53046ba4"
import script from "./data-authority-update.vue?vue&type=script&lang=js"
export * from "./data-authority-update.vue?vue&type=script&lang=js"
import style0 from "./data-authority-update.vue?vue&type=style&index=0&id=53046ba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports